import { TweenLite, TimelineLite, Elastic, Expo } from 'gsap/TweenMax';

import { qs, qsa } from '@/scripts/utils';

export const buttonIn = ((el) => {
  const btns = qsa(`.btn-js[js-refPage="${el.getAttribute('js-page')}"]`);

  const tl = new TimelineLite({ paused: true });

  btns.forEach((btn, index) => {
    const text = qsa('.btn__wrapper__text > bdi', btn);

    const symbol = qs('.btn__img', btn);

    const tlBtn = new TimelineLite();

    tlBtn
      .add('start')
      .set(btn, { autoAlpha: 1, clearProps: 'all' })
      .staggerFrom(text, 0.75, {
        yPercent: 100,
        autoAlpha: 0,
        skewX: -20,
        ease: Elastic.easeOut.config(0.8, 1),
        clearProps: 'all',
      }, 0.25)
      .from(symbol, 0.7, {
        y: -14,
        autoAlpha: 0,
        clearProps: 'all',
        ease: Elastic.easeOut.config(0.8, 1),
      }, 'start+=0.2')
      .to(qs('.btn__border svg path', btn), 0.5, {
        strokeDashoffset: 0,
        ease: Expo.easeNone,
        clearProps: 'all',
      }, 'start+=0.4');

    tl.add(tlBtn, 0.4 * index);
  });

  return tl;
});

export const buttonOut = ((el) => {
  const btns = qsa(`.btn-js[js-refPage="${el.getAttribute('js-page')}"]`);

  const tl = new TimelineLite({ paused: true });

  btns.forEach((btn) => {
    const symbol = qs('.btn__img', btn);
    const path = qs('.btn__border svg path', btn);

    const dashoffset = Math.ceil(path.getTotalLength());
    const dasharray = Math.ceil(path.getTotalLength());

    const text = qsa('.btn__wrapper__text > bdi', btn);

    const tlBtn = new TimelineLite({
      onComplete: () => {
        TweenLite.set(el, { autoAlpha: 0 });
        TweenLite.set(symbol, { clearProps: 'all' });
        TweenLite.set(text, { clearProps: 'all' });
      },
    });

    tl
      .add('start')
      .to(path, 0.5, {
        strokeDashoffset: dashoffset,
        strokeDasharray: dasharray,
        ease: Expo.easeNone,
      })
      .to(symbol, 0.7, {
        y: -14,
        autoAlpha: 0,
        ease: Elastic.easeOut.config(0.8, 1),
      }, 'start+=0.2')
      .staggerTo(text, 0.75, {
        yPercent: 100,
        autoAlpha: 0,
        skewX: -20,
        ease: Elastic.easeOut.config(0.8, 1),
      }, -0.25, 'start+=0.4');

    tl.add(tlBtn);
  });

  return tl;
});



// WEBPACK FOOTER //
// ./src/scripts/timelines/buttonsTransitions.js